export default __webpack_public_path__ + "static/media/flag.f018710c.svg";